import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CashFlowState {
  currentBalance: number;
  initialBalance: number;
}

const initialState: CashFlowState = {
  currentBalance: 0,
  initialBalance: 5000,
};

const cashFlowSlice = createSlice({
  name: 'cashFlow',
  initialState,
  reducers: {
    setCurrentBalance(state, action: PayloadAction<number>) {
      state.currentBalance = action.payload;
    },
    setInitialBalance(state, action: PayloadAction<number>) {
      state.initialBalance = action.payload;
    },
  },
});

export const { setCurrentBalance, setInitialBalance } = cashFlowSlice.actions;
export default cashFlowSlice.reducer;
